import supabase from "../utils/supabase";
import { persistence, STORAGE_KEYS } from "../utils/persistence";

export async function login(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  // Store auth data in localStorage
  if (data) {
    persistence.set(STORAGE_KEYS.AUTH, data);
    persistence.set(STORAGE_KEYS.USER, data.user);
    persistence.set(STORAGE_KEYS.SESSION, data.session);
  }

  return data;
}

export function logout() {
  persistence.remove(STORAGE_KEYS.AUTH);
  persistence.remove(STORAGE_KEYS.USER);
  persistence.remove(STORAGE_KEYS.SESSION);
}

export function getStoredUser() {
  return persistence.get(STORAGE_KEYS.USER);
}

export function getStoredSession() {
  return persistence.get(STORAGE_KEYS.SESSION);
}

export function isAuthenticated() {
  return persistence.has(STORAGE_KEYS.AUTH);
}
